<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.0333 4.46667C9.0333 4.67083 9.09168 4.84583 9.23748 4.9625C9.35418 5.10833 9.52914 5.16667 9.73332 5.16667H13.7V14.7333C13.7 14.9375 13.6125 15.1125 13.4958 15.2292C13.35 15.375 13.175 15.4334 13 15.4334H3.2C2.99583 15.4334 2.82083 15.375 2.70417 15.2292C2.55833 15.1125 2.5 14.9375 2.5 14.7333V1.2C2.5 1.025 2.55833 0.850001 2.70417 0.704167C2.82083 0.5875 2.99583 0.5 3.2 0.5H9.0333V4.46667ZM10.9 11.35V11.1167C10.9 10.8833 10.7833 10.7667 10.55 10.7667H5.65C5.41667 10.7667 5.3 10.8833 5.3 11.1167V11.35C5.3 11.5833 5.41667 11.7 5.65 11.7H10.55C10.7833 11.7 10.9 11.5833 10.9 11.35ZM10.9 9.48334V9.25C10.9 9.01665 10.7833 8.90001 10.55 8.90001H5.65C5.41667 8.90001 5.3 9.01665 5.3 9.25V9.48334C5.3 9.71668 5.41667 9.83331 5.65 9.83331H10.55C10.7833 9.83331 10.9 9.71668 10.9 9.48334ZM10.9 7.38334C10.9 7.15 10.7833 7.03336 10.55 7.03336H5.65C5.41667 7.03336 5.3 7.15 5.3 7.38334V7.61668C5.3 7.85002 5.41667 7.96666 5.65 7.96666H10.55C10.7833 7.96666 10.9 7.85002 10.9 7.61668V7.38334ZM13.7 4.05833V4.23334H9.96666V0.5H10.1417C10.3166 0.5 10.4917 0.5875 10.6375 0.704167L13.4958 3.5625C13.6125 3.70834 13.7 3.88333 13.7 4.05833Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
